import { Typography } from '@altibox/design-system-component-lib';
import { css, styled, Interpolation } from 'styled-components';

import { Image } from 'src/components/image';
import { colorCommonBlue190, colorCommonBlue80, colorCommonRed190, colorCommonRed80 } from 'src/styles/colors';
import { spacing2 } from 'src/styles/spacing';

import { AlertType } from './alert-type';

export interface StyledAlertProps {
  type: AlertType;
}

const ICON_HEIGHT = '20px';

const ALERT_TYPE_STYLES: Record<AlertType, Interpolation<object>> = {
  [AlertType.INFO]: css`
    border: 1px solid ${colorCommonBlue80};
    background: ${colorCommonBlue190};
  `,
  [AlertType.ERROR]: css`
    border: 1px solid ${colorCommonRed80};
    background: ${colorCommonRed190};
  `,
};

export const StyledAlert = styled.div<StyledAlertProps>`
  ${(props) => ALERT_TYPE_STYLES[props.type]}
  border-radius: 6px;
  padding: ${spacing2};
`;

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledIcon = styled(Image)`
  height: ${ICON_HEIGHT};
  width: ${ICON_HEIGHT};
  margin-right: ${spacing2};
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
`;

export const StyledDescription = styled(Typography)`
  margin-top: ${spacing2};
`;
